<template>
    <div
        :class="[{'has-error': !!error},formGroupClass]"
    >
        <label v-show="label" :for="name">{{ label }} <span v-show="requireField" class="red">*</span></label>
        <flat-pickr
            v-model="date"
            :config="config"                                                          
            class="form-control" 
            placeholder="Select date"               
            name="date"
            @input="$emit('input', date)"
            @blur="$emit('validate',name,prefix)"
            @keyup="$emit('validate',name,prefix)"
            :disabled="disabled"
        >
        </flat-pickr>
        <small class="error-message" v-show="!!error">กรุณาเลือกวันที่</small>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: "FormDate",
    components: {
        flatPickr
    },
    data () {
        return {
            // Initial value can be a date object as well
            date: this.value,
            // Get more form https://flatpickr.js.org/options/
            config: {
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                allowInput: true,
            },                
        }
    },
    props: {
        error: { required: true },
        formGroupClass: {
            type: String,
        },
        inputClass: {
            type: String,
        },
        type: {
            type: String,
            default: "text",
        },
        value: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
        },
        requireField: {
            type: Boolean,
            default: false,
        },
        optionDatas: {
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    watch: {
        value: function () {
            this.date= this.value
        }
    },
    methods: {
        dateToFormat(value){
            return this.$dayjs(value).format('DD/MM/YYYY');
        },
        formatToDate(value){
            return this.$dayjs(value,'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkFunction(){
            console.log('test',this.date)
        }
    },
};
</script>